// extracted by css-extract-rspack-plugin
export default {"title":"_fa24afc8","description":"_58a0546e"};